//@import dependencies
import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import moment from 'moment';
import NumberFormat from 'react-number-format';
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
// import ModalProgramForm from 'app_components/modules/admin/courseScheduling/modalProgramForm'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import DurationFieldService from 'app_services/components/durationFieldService'
// import ProgramService from 'app_services/admin/program/programService'
import ProgramMasterService from 'app_services/admin/program/programMasterService'
import RegionalService from 'app_services/admin/regional/regionalService'
// import CourseSchedulingModeService from 'app_services/admin/courseScheduling/courseSchedulingModeService'
import CourseSchedulingModeMasterService from 'app_services/admin/courseScheduling/courseSchedulingModeMasterService'
import CourseSchedulingStatusService from 'app_services/admin/courseScheduling/courseSchedulingStatusService'
import CourseSchedulingTypeService from 'app_services/admin/courseScheduling/courseSchedulingTypeService'
import ModularService from 'app_services/admin/modular/modularService'
import CityService from 'app_services/admin/city/cityService'
import CountryService from 'app_services/admin/country/countryService'
import UserService from 'app_services/user/userService';
import CompanyService from 'app_services/admin/company/companyService';
import CourseSchedulingDetailsService from 'app_services/admin/courseScheduling/courseSchedulingDetailsService'
// @end

// @INFO Import Styles
import './../courseSchedulingModule.scss'
import InputFileComponent from 'app_components/commons/InputFileComponent/InputFileComponent';
import CourseSchedulingModuleLayoutMaterialDelivery from './courseSchedulingModuleLayoutMaterialDelivery';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import ModalAttached from 'app_components/modules/ModalAttached/ModalAttached';
import { ICourseSchedulingDetailsHttpResponse } from 'app_types/admin/courseScheduling/courseSchedulingDetailsTypes';
import { IUserListItem } from 'app_types/admin/user/userTypes';
import ModalReprogramingForm from '../../../../ModalReprogramingForm/ModalReprogramingForm';
import { CourseSchedulingModes } from 'app_types/admin/courseScheduling/courseSchedulingModeTypes';
import { CertificateCriteriaTypeCourse } from 'app_types/admin/certificateCriteria/certificateCriteriaTypes';

const OFFER_MAX_LENGTH = 16

// @ADD Component types
interface ICourseSchedulingModuleLayoutProps {
  processing: boolean
  onHandleSubmit: (data: any) => void
  editData?: any
  customErrors?: any
  viewer: boolean
}

interface IOptionSelect{
  label: string;
  value: string;
}

const CourseSchedulingModuleLayout: React.FC<ICourseSchedulingModuleLayoutProps> = (props) => {

  const fileSize = 500;

  const withoutTutor = {value: 'withoutTutor', label: 'Virtual sin tutor'}
  const quickLearning = {value: 'quickLearning', label: 'Quick Learning'}

  const inputFileComponentMessage = `Sube un archivo de peso máximo ${fileSize}KB, en extensión PNG, tamaño minimo ancho 100px alto 50px y máximo ancho 2000px y alto 2000px`
  // @Services
  const durationFieldService: DurationFieldService = new DurationFieldService()
  // const programService: ProgramService = new ProgramService()
  const companyService: CompanyService = new CompanyService()
  const programMasterService: ProgramMasterService = new ProgramMasterService()
  const regionalService: RegionalService = new RegionalService()
  const courseSchedulingModeMasterService: CourseSchedulingModeMasterService = new CourseSchedulingModeMasterService()
  const userService: UserService = new UserService();
  // const courseSchedulingModeService: CourseSchedulingModeService = new CourseSchedulingModeService()
  const courseSchedulingStatusService: CourseSchedulingStatusService = new CourseSchedulingStatusService()
  const courseSchedulingTypeService: CourseSchedulingTypeService = new CourseSchedulingTypeService()
  const modularService: ModularService = new ModularService()
  const cityService: CityService = new CityService()
  const countryService: CountryService = new CountryService()
  const courseSchedulingDetailsService: CourseSchedulingDetailsService = new CourseSchedulingDetailsService()

  const [radioValue, setRadioValue] = useState(0);
  const [schedulingModeDetailsRadioValue, setSchedulingModeDetailsRadioValue] = useState<string | null>(null)

  const [reprogramingValue, setReprogramingValue] = useState<string|undefined>(undefined)
  const [hasCost, setHasCost] = useState<boolean>(false)
  const [virtualOffertStatus, setVirtualOffertStatus] = useState<boolean>(false)
  const [statusConditionsValidated, setStatusConditionsValidated] = useState(false);
  const [programsConditionsValidated, setProgramsConditionsValidated] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [cityStatus, setCityStatus] = useState(false);
  const [addressStatus, setAddressStatus] = useState<boolean>(false);
  const [classroomStatus, setClassroomStatus] = useState<boolean>(false);
  const [choiceModality, setChoiceModality] = useState(false);
  const [modalityValue, setModalityValue] = useState<{ value: string, label: string } | null>(null);
  const [programTypeValue, setProgramTypeValue] = useState<{ value: string, label: string } | null>(null);
  const [contacts, updateContacts] = useState<any[]>([]);

  const [regionalStatus, setRegionalStatus] = useState(false);
  const [auditorCertificate, setAuditorCertificate] = useState<{status: boolean, name: string, items: Array<string>}>({
    status: false,
    name: "",
    items: []
  })
  const [accountExecutiveStatus, setAccountExecutiveStatus] = useState(false);
  const [discountValue, setDiscountStatus] = useState<string | number | null>(null);

  // const [modalProgramFormStatus, setModalProgramFormStatus] = useState<boolean>(false)

  const [listOfCourseSchedulings, setListOfCourseSchedulings] = useState<Array<any>>([])
  const [listOfStatus, setListOfStatus] = useState<Array<any>>([])
  const [listOfServiceTypes, setListOfServiceTypes] = useState<Array<any>>([])
  const [listOfTypes, setListOfTypes] = useState<Array<any>>([])
  const [listOfModes, setListOfModes] = useState<Array<any>>([])
  const [listOfPrograms, setListOfPrograms] = useState<Array<any>>([])
  const [listOfRegionals, setListOfRegionals] = useState<Array<any>>([])
  const [listOfCities, setListOfCities] = useState<Array<any>>([])
  const [listOfCountries, setListOfCountries] = useState<Array<any>>([])
  const [listOfModulars, setListOfModulars] = useState<Array<any>>([])
  const [listOfAccountExecutives, setListOfAccountExecutives] = useState<Array<any>>([])
  const [listOfCompanies, setListOfCompanies] = useState<Array<any>>([])
  const [listOfLogisticAssistant, updateListOfLogisticAssistant] = useState<IOptionSelect[]>([]);
  const [listOfContacts, updateListOfContacts] = useState<IOptionSelect[]>([]);

  const [priceCop, setPriceCop] = useState<{ formated: string, value: string }>({ formated: '', value: '0' })
  const [priceUsd, setPriceUsd] = useState<{ formated: string, value: string }>({ formated: '', value: '0' })
  const [certificatePriceCOP, setCertificatePriceCOP] = useState<{ formated: string, value: string }>({ formated: '', value: '0' })
  const [certificatePriceUSD, setCertificatePriceUSD] = useState<{ formated: string, value: string }>({ formated: '', value: '0' })

  const [attachedId, updateAttachedId] = useState<string | undefined>('');
  const [openAttachments, updateOpenAttachments] = useState<boolean>(false);
  const [attachedStudentId, updateAttachedStudentId] = useState<string | undefined>('');
  const [attachedApprovalCriteriaId, setAttachedApprovalCriteriaId] = useState<string | undefined>('');
  const [attachedTechnicalGuidelineId, setAttachedTechnicalGuidelineId] = useState<string | undefined>('');
  const [attachedCertificateCriteriaId, setAttachedCertificateCriteriaId] = useState<string | undefined>('');
  const [attachedSpecialServiceConditionsId, setAttachedSpecialServiceConditionsId] = useState<string | undefined>('');
  const [openAttachmentsStudent, updateOpenAttachmentsStudent] = useState<boolean>(false);
  const [openTechnicalGuideline, updateOpenTechnicalGuideline] = useState<boolean>(false);
  const [openAttachedApprovalCriteria, setOpenAttachedApprovalCriteria] = useState<boolean>(false);
  const [openAttachedCertificateCriteria, setOpenAttachedCertificateCriteria] = useState<boolean>(false);
  const [openAttachedSpecialServiceConditions, setOpenAttachedSpecialServiceConditions] = useState<boolean>(false);
  const [openReprogramingForm, updateOpenReprogramingForm] = useState<boolean>(false);
  const [defaultValueServiceType, updateDefaultValueServiceType] = useState<{value: string, label: string}>({value: '', label: ''})

  const { t } = useTranslation()

  const formHook = useForm({ mode: 'onChange' })

  const clientSpy = formHook.watch('client');
  const schedulingStatusSpy = formHook.watch('schedulingStatus');
  const materialDeliverySpy = formHook.watch('material_delivery');
  const contactSpy = formHook.watch('contact');
  const modalitySpy = formHook.watch('schedulingMode');
  const typeCourseSpy = formHook.watch('typeCourse')
  const serviceTypeSpy = formHook.watch('serviceType');
  const hasMultipleCertificate = formHook.watch('hasMultipleCertificate');
  const schedulingTypeSpy = formHook.watch('schedulingType')
  const isOpen = schedulingTypeSpy?.label === 'Abierto'
  const isOnlineAndOpenLine = useMemo(() => {
    return ['Presencial - En linea', 'En linea'].includes(modalitySpy?.label)
      && schedulingModeDetailsRadioValue === 'online'
      && schedulingTypeSpy?.label === 'Abierto'
  }, [modalitySpy, schedulingModeDetailsRadioValue, schedulingTypeSpy])

  const serviceValidityEnabled = useMemo(() => {
    if (['Virtual'].includes(modalitySpy?.label) && [quickLearning.value, withoutTutor.value].includes(serviceTypeSpy?.value)) {
      return true
    }
    return false
  }, [modalitySpy, serviceTypeSpy])

  const isMoocOrFree = !!typeCourseSpy

  const signatures = [
    {
      field: 'signature_1',
      label: 'segundo',
      body: {
        url: props.editData?.signature_1,
        name: props.editData?.signature_1_name,
        position: props.editData?.signature_1_position,
        company: props.editData?.signature_1_company
      }
    },
    {
      field: 'signature_2',
      label: 'tercero',
      body: {
        url: props.editData?.signature_2,
        name: props.editData?.signature_2_name,
        position: props.editData?.signature_2_position,
        company: props.editData?.signature_2_company
      }
    },
  ]

  useEffect(() => {
    if (isMoocOrFree) {
      formHook.setValue('hasMultipleCertificate', true)
      formHook.setValue('hasCost', false)
      setHasCost(false)
    }
  }, [isMoocOrFree])

  useEffect(() => {
    getLogisticAssistants();
    getStatus()
    getModes()
    getClients()
    getTypes()
    getModulars()
    getCities()
    getCountries()
    getRegionals()
    getAccountExecutive()
    formHook.register('typeCourse')
    getServiceType()
  }, [])

  useEffect(() => {
    if (clientSpy?.value) {
      getContacts(clientSpy.value);
    }
  }, [clientSpy])

  const getLogisticAssistants = async () => {
    const usersResponse = await userService.get({
      role_names: ['logistics_assistant'],
      sort: 'first_name'
    })
    if (usersResponse?.code === 200 && usersResponse?.users?.length) {
      const _users:IUserListItem[] = usersResponse.users;
      updateListOfLogisticAssistant(_users.map((_u) => {
        return {
          label: `${_u.profile?.first_name} ${_u.profile?.last_name}`,
          value: _u._id
        }
      }))
    }
  }

  const getContacts = async (companyId: string) => {
    const usersResponse = await userService.get({
      role_names: ['company'],
      company: companyId
    })
    if (usersResponse?.code === 200 && usersResponse?.users?.length) {
      const _users:IUserListItem[] = usersResponse.users;
      updateListOfContacts(_users.map((_u) => {
        return {
          label: `${_u.profile?.first_name} ${_u.profile?.last_name}`,
          value: _u._id
        }
      }))
      updateContacts(_users);
    }
  }

  const getCourseSchedulingDetails = async (course_scheduling_id: string) => {
    const itemList: ICourseSchedulingDetailsHttpResponse | null = await courseSchedulingDetailsService.list({
      course_scheduling: course_scheduling_id
    })
    const items: Array<any> = []
    if (itemList?.status_code === 'success') {
      itemList?.schedulings.map((item: any) => {
        items.push({ value: item._id, label: item.course.name })
      })
    }
    setListOfCourseSchedulings(items)
  }

  const getStatus = async () => {
    const isNew = (props?.editData) ? false : true
    const items: Array<any> = []
    const response = await courseSchedulingStatusService.list()
    if (response?.courseSchedulingStatuses) {
      response.courseSchedulingStatuses.map((item: any) => {
        if (isNew) {
          if (item.name === 'Programado') {
            items.push({ value: item._id, label: item.name })
          }
        } else {
          items.push({ value: item._id, label: item.name })
        }
      })
    }
    setListOfStatus(items)
  }

  const getServiceType = () => {
    const items: Array<any> = []
    items.push(withoutTutor)
    items.push(quickLearning)
    setListOfServiceTypes(items)
  }

  const getModes = async () => {
    const items: Array<any> = []
    const response = await courseSchedulingModeMasterService.list()
    if (response?.categories) {
      response?.categories.map((item: any) => {
        items.push({ value: item.id, label: item.name })
      })
    }
    setListOfModes(items)
  }

  const getClients = async () => {
    const items: Array<any> = []
    const response = await companyService.list()
    if (response?.companies) {
      response?.companies.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
    }
    setListOfCompanies(items)
  }

  const getTypes = async () => {
    const items: Array<any> = []
    const response = await courseSchedulingTypeService.list()
    if (response?.courseSchedulingTypes) {
      response?.courseSchedulingTypes.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
    }
    setListOfTypes(items)
  }

  const getModulars = async () => {
    const items: Array<any> = []
    const response = await modularService.list()
    if (response?.modulars) {
      response.modulars.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
    }
    setListOfModulars(items)
  }

  const getCountries = async () => {
    const items: Array<any> = []
    const response = await countryService.list()
    if (response?.countries) {
      response.countries.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
    }
    setListOfCountries(items)
  }

  const getCities = async () => {
    const items: Array<any> = []
    const response = await cityService.list()
    if (response?.cities) {
      response.cities.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
    }
    setListOfCities(items)
  }

  const getPrograms = async (categoryId: number) => {
    const programs: Array<any> = []
    const programsResponse = await programMasterService.list({
      categoryId
    })
    if (programsResponse?.courses) {
      programsResponse.courses.map((program: any) => {
        programs.push({ value: program.id, label: `${program.name} | ${program.fullname}`, auditorcertificate:  program.auditorcertificate })
      })
    }
    setListOfPrograms(programs)
  }

  const getRegionals = async () => {
    const regionals: Array<any> = []
    const regionalResponse = await regionalService.list()
    if (regionalResponse?.regionals) {
      regionalResponse.regionals.map((regional: any) => {
        regionals.push({ value: regional._id, label: regional.name })
      })
    }
    setListOfRegionals(regionals)
  }

  const getAccountExecutive = async () => {
    const users: Array<any> = []
    const userResponse = await userService.get({ role_names: 'account_executive' , sort: 'first_name'})
    if (userResponse?.users) {
      userResponse.users.map((user: any) => {
        users.push({ value: user._id, label: `${user.profile.first_name} ${user.profile.last_name}` })
      })
    }
    setListOfAccountExecutives(users)
  }

  useEffect(() => {
    if (modalityValue) {
      if (modalityValue?.label === 'Virtual') {
        formHook.setValue('regional', null)
        setRegionalStatus(false)
        setAccountExecutiveStatus(false);
        setSchedulingModeDetailsRadioValue(null)
        setChoiceModality(false)
        setCityStatus(false)
      } else if (modalityValue?.label === 'Presencial - En linea') {
        formHook.setValue('regional', null)
        setChoiceModality(true)
        if (!schedulingModeDetailsRadioValue) {
          setSchedulingModeDetailsRadioValue('in_situ')
          setRegionalStatus(true)
          setAccountExecutiveStatus(true)
        }
      }
    }
  }, [modalityValue, programTypeValue])

  useEffect(() => {
    if (schedulingModeDetailsRadioValue) {
      if (schedulingModeDetailsRadioValue === 'in_situ') {
        setCityStatus(true)
        setRegionalStatus(true)
        setAccountExecutiveStatus(false)
        setAddressStatus(true)
        setClassroomStatus(true)
        if (programTypeValue?.label === 'Abierto') {
          setAccountExecutiveStatus(true)
        }

      } else if (schedulingModeDetailsRadioValue === 'online') {
        setCityStatus(false)
        setAccountExecutiveStatus(false)
        setAddressStatus(false)
        setClassroomStatus(false)
        if (!programTypeValue) {
          setRegionalStatus(false)
          // setAccountExecutiveStatus(false)
        } else if (programTypeValue?.label === 'Abierto') {
          setRegionalStatus(false)
          // setAccountExecutiveStatus(false)
        } else {
          setRegionalStatus(true)
          // setAccountExecutiveStatus(true)
        }
      }
    }
  }, [schedulingModeDetailsRadioValue, programTypeValue])

  const modalityChange = (data: any) => {
    formHook.setValue('program', null)
    setModalityValue(data)
    if (data?.value) {
      getPrograms(data.value)
    }

    setCityStatus(false)
    setVirtualOffertStatus(false)
  }

  const programChange = (data: any) => {
    if (data?.auditorcertificate) {
      setAuditorCertificate({
        status: true,
        name: data?.auditorcertificate,
        items: []
      })

    } else {
      setAuditorCertificate({
        status: false,
        name: "",
        items: []
      })
    }
  }

  const programTypeChange = (data: any) => {
    setProgramTypeValue(data)
    if (data?.label === 'Abierto') {
      setVirtualOffertStatus(true)
    } else {
      setVirtualOffertStatus(false)
    }
  }

  const handleChangeHasCost = (e: any) => {
    setHasCost(!hasCost)
  }

  useEffect(() => {
    if (props?.editData && firstLoad) {
      getCourseSchedulingDetails(props.editData._id)

      setCityStatus(false)
      setHasCost((props?.editData?.details?.hasCost) ? props?.editData?.details?.hasCost : false)
      if (props?.editData?.details?.schedulingType) {
        setProgramTypeValue({ value: props?.editData?.details?.schedulingType._id, label: props?.editData?.details?.schedulingType.name })
      }


      if (props?.editData?.details?.hasCost === true) {
        if (props?.editData?.details?.priceCOP) {
          setPriceCop({ formated: props?.editData?.details?.priceCOP, value: props?.editData?.details?.priceCOP })
        }
        if (props?.editData?.details?.priceUSD) {
          setPriceUsd({ formated: props?.editData?.details?.priceUSD, value: props?.editData?.details?.priceUSD })
        }
        if (props?.editData?.details?.discount && props?.editData?.details?.discount > 0) {
          setDiscountStatus(props?.editData?.details?.discount)
        }
      }

      if (props?.editData?.details?.certificatePriceCOP) {
        setCertificatePriceCOP({ formated: props?.editData?.details?.certificatePriceCOP, value: props?.editData?.details?.certificatePriceCOP })
      }
      if (props?.editData?.details?.certificatePriceUSD) {
        setCertificatePriceUSD({ formated: props?.editData?.details?.certificatePriceUSD, value: props?.editData?.details?.certificatePriceUSD })
      }
      if (isMoocOrFree) {
      }

      if (props?.editData?.details?.in_design === true) {
        setRadioValue(1)
      }

      if (props?.editData?.details?.schedulingType.name === 'Abierto') {
        setVirtualOffertStatus(true)
      }



      if (props?.editData?.details?.schedulingMode) {
        getPrograms(parseInt(props?.editData?.details?.schedulingMode.moodle_id))
        if (['Presencial', 'En linea'].includes(props?.editData?.details?.schedulingMode.name)) {
          props.editData.details.schedulingMode.name = 'Presencial - En linea'
        }
        if (props?.editData?.details?.schedulingMode.name === 'Virtual') {
          setRegionalStatus(false)
          setAccountExecutiveStatus(false)
        } else if (props?.editData?.details?.schedulingMode.name === 'Presencial - En linea') {
          setChoiceModality(true)
          if (!props?.editData?.details?.schedulingModeDetails) {
            setSchedulingModeDetailsRadioValue('in_situ')
            setRegionalStatus(true)
            setAccountExecutiveStatus(false)
          } else {
            if (props?.editData?.details?.schedulingModeDetails === "") {
              setSchedulingModeDetailsRadioValue('in_situ')
              setRegionalStatus(true)
              setAccountExecutiveStatus(false)
            } else {
              setSchedulingModeDetailsRadioValue(props?.editData?.details?.schedulingModeDetails)

              if (props?.editData?.details?.schedulingModeDetails === 'in_situ') {
                setCityStatus(true)
                setRegionalStatus(true)
                setAccountExecutiveStatus(false)
                if (props?.editData?.details?.schedulingType) {
                  if (props?.editData?.details?.schedulingType.name === 'Abierto') {
                    setAccountExecutiveStatus(true)
                  }
                }
              } else if (props?.editData?.details?.schedulingModeDetails === 'online') {
                if (props?.editData?.details?.schedulingType) {
                  if (props?.editData?.details?.schedulingType.name === 'Abierto') {
                    setRegionalStatus(false)
                    // setAccountExecutiveStatus(false)
                  } else {
                    setRegionalStatus(true)
                    // setAccountExecutiveStatus(true)
                  }
                }
              }
            }
          }
        } else {
          setRegionalStatus(true)
          setAccountExecutiveStatus(false)
        }
      }

      if (props?.editData?.details?.withoutTutor || props?.editData?.details?.quickLearning) {
        if (props?.editData?.details?.withoutTutor) updateDefaultValueServiceType(withoutTutor)
        if (props?.editData?.details?.quickLearning) updateDefaultValueServiceType(quickLearning)
      }
      setFirstLoad(false)
    }
  }, [props, props.editData])

  useEffect(() => {
    if (statusConditionsValidated === false && listOfStatus.length > 0) {
      // console.log('entro a useEffect', ) {}
      if (props.editData?.schedulingStatus?.name === 'Programado') {
        const _list = listOfStatus.reduce((accum, element) => {
          if (element.label !== 'Ejecutado') {
            accum.push(element)
          }
          return accum
        }, [])
        setListOfStatus(_list)
      } else if (props.editData?.schedulingStatus?.name === 'Confirmado') {
        const _list = listOfStatus.reduce((accum, element) => {
          if (element.label !== 'Programado') {
            accum.push(element)
          }
          return accum
        }, [])
        setListOfStatus(_list)
      } else if (props.editData?.schedulingStatus?.name === 'Ejecutado') {
        const _list = listOfStatus.reduce((accum, element) => {
          if (element.label === 'Ejecutado') {
            accum.push(element)
          }
          return accum
        }, [])
        setListOfStatus(_list)
      } else if (props.editData?.schedulingStatus?.name === 'Cancelado') {
        const _list = listOfStatus.reduce((accum, element) => {
          if (element.label === 'Cancelado') {
            accum.push(element)
          }
          return accum
        }, [])
        setListOfStatus(_list)
      }
      setStatusConditionsValidated(true)
    }
  }, [props, props.editData, listOfStatus])

  useEffect(() => {
    if (programsConditionsValidated === false && listOfPrograms.length > 0) {
      if (props?.editData?.details?.program) {
        const _list = listOfPrograms.reduce((accum, element) => {
          if (props?.editData?.details?.program.moodle_id === element.value.toString()) {
            accum[props?.editData?.details?.program.moodle_id] = element
          }
          return accum
        }, {})

        if (_list[props?.editData?.details?.program.moodle_id]) {
          programChange(_list[props?.editData?.details?.program.moodle_id])
        }
      }
      setProgramsConditionsValidated(true)
    }
  }, [props, props.editData, listOfPrograms])

  const getListOfRegionalsForSelect = () => {
    if ((schedulingModeDetailsRadioValue === 'online' || modalitySpy?.label === 'Virtual') && programTypeValue?.label === 'Abierto') {
      return listOfRegionals;
    } else {
      return listOfRegionals.filter((r) => r.label !== 'Transversal');
    }
  }

  const checkCertificateMultipleStatus = () => {
    let status = true;
    if (props?.editData?.multipleCertificate) {
      status = props?.editData?.multipleCertificate?.editingStatus;
    }
    return status;
  }

  const getContactObject = () => {
    if ( contacts?.length && contactSpy?.value ) {
      const user = contacts.find((c: any) => c._id === contactSpy.value);
      return user;
    }
    return undefined;
  }

  const reprogramingFormClosed = (data: any) => {
    updateOpenReprogramingForm(false)
    setReprogramingValue(undefined)
    formHook.setValue('reprograming', undefined)
    if (data?.status === 'saved' && data?.data?.reason) {
      setReprogramingValue(data?.data?.reason?.value)
      props.onHandleSubmit(formHook.getValues())
    }
  }

  const handleChangeTypeCourse = (typeCourse: CertificateCriteriaTypeCourse) => {
    if (typeCourseSpy === typeCourse) {
      formHook.setValue('typeCourse', undefined)
    } else {
      formHook.setValue('typeCourse', typeCourse)
    }
  }

  useEffect(() => {
    if (props?.editData?.details?.typeCourse) {
      formHook.setValue('typeCourse', props?.editData?.details?.typeCourse)
    }
  }, [props?.editData?.details?.typeCourse])

  return(
    <div className='course_scheduling_form-component'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

          <input type="hidden" name="reprograming" value={reprogramingValue} ref={formHook.register({ required: false })} />
          {props.editData?.details?.metadata?.service_id ? (
            <div>
              <h4>ID de Servicio: {props.editData?.details?.metadata?.service_id}</h4>
            </div>
          ) : null}

          <div className="container-main-form">
            <div>
              <div className="d-flex align-items-center mb-2">
                <h3 className="form-title">{t("modules.course_scheduling.general_information")}</h3>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='schedulingMode'>{t('labels.course_scheduling.schedulingMode')}</label>
                  <ReactSelectComponent
                    identifier='schedulingMode'
                    options={listOfModes}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.schedulingMode) ? [{ value: parseInt(props?.editData?.details?.schedulingMode.moodle_id), label: props?.editData?.details?.schedulingMode.name }] : []}
                    isMulti={false}
                    required={true}
                    onChangeSelect={modalityChange}
                  />
                  {formHook.errors.schedulingMode && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              {modalitySpy?.label === CourseSchedulingModes.VIRTUAL && (
                <>
                  <div className='col-md-12'>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                    >
                      <label className={"content-input"}>
                        <input
                          type='checkbox'
                          onClick={() => handleChangeTypeCourse(CertificateCriteriaTypeCourse.FREE)}
                          checked={typeCourseSpy === CertificateCriteriaTypeCourse.FREE}
                        />
                        &nbsp;Gratuito
                      </label>
                      <label className={"content-input"}>
                        <input
                          type='checkbox'
                          onClick={() => handleChangeTypeCourse(CertificateCriteriaTypeCourse.MOOC)}
                          checked={typeCourseSpy === CertificateCriteriaTypeCourse.MOOC}
                        />
                        &nbsp;Mooc
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor='serviceType'>{t('labels.course_scheduling.serviceType')}</label>
                      <ReactSelectComponent
                        identifier='serviceType'
                        options={listOfServiceTypes}
                        formHooks={formHook}
                        defaultValue={[defaultValueServiceType]}
                        isMulti={false}
                        required={false}
                      />
                      {formHook.errors.serviceType && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    </div>
                  </div>
                </>
              )}

              {choiceModality && (
                <div className="col-md-12">
                  <div className="form-group">
                    {/* <label htmlFor="">{t("modules.course_scheduling.modality_details.title")}</label><br /> */}
                    <label className={"content-input"}>
                      <input
                        type="radio"
                        name="schedulingModeDetails"
                        ref={formHook.register()}
                        value="in_situ"
                        checked={schedulingModeDetailsRadioValue === 'in_situ'}
                        onChange={(e) => setSchedulingModeDetailsRadioValue('in_situ')}
                      />
                      &nbsp;{t('modules.course_scheduling.modality_details.in_situ')}
                    </label>&nbsp;&nbsp;&nbsp;
                    <label className={"content-input"}>
                      <input
                        type="radio"
                        name="schedulingModeDetails"
                        ref={formHook.register()}
                        value="online"
                        checked={schedulingModeDetailsRadioValue === 'online'}
                        onChange={(e) => setSchedulingModeDetailsRadioValue('online')}
                      />
                      &nbsp;{t('modules.course_scheduling.modality_details.online')}
                    </label>
                  </div>
                </div>
              )}

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='modular'>{t('labels.course_scheduling.modular')}</label>
                  <ReactSelectComponent
                    identifier='modular'
                    options={listOfModulars}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.modular) ? [{ value: props?.editData?.details?.modular._id, label: props?.editData?.details?.modular.name }] : []}
                    isMulti={false}
                    required={true}
                  />
                  {formHook.errors.modular && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='program'>{t('labels.course_scheduling.program')}</label>
                  <div className="program-field">
                    <ReactSelectComponent
                      identifier='program'
                      options={listOfPrograms}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.program) ? [{ value: parseInt(props?.editData?.details?.program.moodle_id), label: `${props?.editData?.details?.program.code} | ${props?.editData?.details?.program.name}` }] : []}
                      isMulti={false}
                      required={true}
                      onChangeSelect={programChange}
                    />
                    {formHook.errors.program && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='schedulingType'>{t('labels.course_scheduling.schedulingType')}</label>
                  <ReactSelectComponent
                    identifier='schedulingType'
                    options={listOfTypes}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.schedulingType) ? [{ value: props?.editData?.details?.schedulingType._id, label: props?.editData?.details?.schedulingType.name }] : []}
                    isMulti={false}
                    required={true}
                    onChangeSelect={programTypeChange}
                  />
                  {formHook.errors.schedulingType && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='schedulingStatus'>{t('labels.course_scheduling.schedulingStatus')}</label>
                  <ReactSelectComponent
                    identifier='schedulingStatus'
                    options={listOfStatus}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.schedulingStatus) ? [{ value: props?.editData?.details?.schedulingStatus._id, label: props?.editData?.details?.schedulingStatus.name }] : []}
                    isMulti={false}
                    required={true}
                  />
                  {formHook.errors.schedulingStatus && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor='startDate'>{t('labels.course_scheduling.startDate')}</label>
                  <input
                    type='date'
                    className='form-control'
                    name='startDate'
                    defaultValue={moment.utc(props?.editData?.details?.startDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                    ref={formHook.register({ required: true })}
                  />
                  {formHook.errors.startDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor='endDateLabel'>{t('labels.course_scheduling.endDate')}</label>
                  <input
                    type={isMoocOrFree ? 'date' : 'text'}
                    className='form-control'
                    name={isMoocOrFree ? 'endDate' : 'endDateLabel'}
                    defaultValue={props?.editData?.details?.endDate ? moment.utc(props?.editData?.details?.endDate).format('YYYY-MM-DD') : isMoocOrFree ? moment.utc().format('YYYY-MM-DD') : '-'}
                    ref={formHook.register({ required: isMoocOrFree ? true : false })}
                    disabled={!isMoocOrFree}
                  />
                  {formHook.errors.endDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              {serviceValidityEnabled ? (
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='serviceValidity'>Periodo de vigencia</label>
                    {formHook.errors.serviceValidity && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='serviceValidity'
                      name='serviceValidity'
                      className={`form-control ${formHook.errors.serviceValidity && 'is-invalid'}`}
                      type='text'
                      placeholder='0d 0h 0m 0s'
                      ref={formHook.register({ required: true })}
                      defaultValue={(props?.editData?.serviceValidity) ? durationFieldService.getDurationFormated(props?.editData?.serviceValidity, 'short') : '30d'}
                    />
                  </div>
                  {props.customErrors?.service_validity_invalid && <div className='custom-invalid-feedback'>{props.customErrors?.service_validity_invalid}</div>}
                </div>
              ):formHook.unregister('serviceValidity')}

              {/* {regionalStatus && ( */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='regional'>{t('labels.course_scheduling.regional')}</label>
                    <ReactSelectComponent
                      identifier='regional'
                      options={getListOfRegionalsForSelect()}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.regional) ? [{ value: props?.editData?.details?.regional._id, label: props?.editData?.details?.regional.name }] : []}
                      isMulti={false}
                      required={true}
                    />
                    {formHook.errors.regional && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
              {/* )} */}

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='material_assistant'>{t('labels.material_delivery.material_assistant')}</label>
                  <ReactSelectComponent
                    identifier='material_assistant'
                    options={listOfLogisticAssistant}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.material_assistant) ? [{value: props?.editData?.details?.material_assistant?._id, label: `${props?.editData?.details?.material_assistant?.profile?.first_name} ${props?.editData?.details?.material_assistant?.profile?.last_name}` }] : []}
                    isMulti={false}
                    required={true}
                  />
                  {formHook.errors.material_assistant && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              {/* {accountExecutiveStatus && ( */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='account_executive'>{t('labels.course_scheduling.account_executive')}</label>
                    <ReactSelectComponent
                      identifier='account_executive'
                      options={listOfAccountExecutives}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.account_executive) ? [{ value: props?.editData?.details?.account_executive._id, label: `${props?.editData?.details?.account_executive.profile.first_name} ${props?.editData?.details?.account_executive.profile.last_name}` }] : []}
                      isMulti={false}
                      required={true}
                    />
                    {formHook.errors.account_executive && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
              {/* )} */}

              {schedulingStatusSpy?.label === 'Confirmado' && schedulingModeDetailsRadioValue === 'in_situ' ?
                <div className="col-md-12">
                  <Form.Group>
                    <Form.Label>{t('labels.logistics_supply')}</Form.Label>
                    <Form.Control
                      as="select"
                      id="logistics_supply"
                      name='logistics_supply'
                      className={`${formHook.errors.logistics_supply && 'is-invalid'}`}
                      ref={formHook.register()}
                      defaultValue={(props?.editData?.logistics_supply) ? props?.editData?.logistics_supply : 'digital'}
                    >
                      <option value='business' >Empresa</option>
                      <option value='icontec' >Icontec</option>
                      <option value='not_applicable' >No aplica</option>
                    </Form.Control>
                  </Form.Group>
                </div>
              : formHook.unregister('logistics_supply')}

              {schedulingStatusSpy?.label === 'Confirmado' ?
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='certificate_address'>{t('labels.certificate_address')}</label>
                    {formHook.errors.certificate_address && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='certificate_address'
                      name='certificate_address'
                      className={`form-control ${formHook.errors.certificate_address && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register()}
                      defaultValue={(props?.editData?.certificate_address) ? props?.editData?.certificate_address : ''}
                    />
                  </div>
                </div>
              : formHook.unregister('certificate_address')}

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='country'>{t('labels.course_scheduling.country')}</label>
                  <ReactSelectComponent
                    identifier='country'
                    options={listOfCountries}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.country) ? [{ value: props?.editData?.details?.country._id, label: props?.editData?.details?.country.name }] : []}
                    isMulti={false}
                    required={true}
                  />
                  {formHook.errors.country && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>

              {/* {cityStatus && ( */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='city'>{t('labels.course_scheduling.city')}</label>
                    <ReactSelectComponent
                      identifier='city'
                      options={listOfCities}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.city) ? [{ value: props?.editData?.details?.city._id, label: props?.editData?.details?.city.name }] : []}
                      isMulti={false}
                      required={true}
                      isCreatable={true}
                    />
                    {formHook.errors.city && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
              {/* )} */}

              {addressStatus && schedulingModeDetailsRadioValue === 'in_situ' && schedulingStatusSpy?.label === 'Confirmado' ? (
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='address'>{t('labels.course_scheduling.address')}</label>
                    {formHook.errors.address && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      name='address'
                      className={`form-control ${formHook.errors.address && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: true })}
                      defaultValue={(props?.editData?.address) ? props?.editData?.address : ''}
                    />
                  </div>
                </div>
              ):formHook.unregister('address')}

              {classroomStatus && schedulingModeDetailsRadioValue === 'in_situ' && schedulingStatusSpy?.label === 'Confirmado' ? (
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='classroom'>{t('labels.course_scheduling.classroom')}</label>
                    {formHook.errors.classroom && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      name='classroom'
                      className={`form-control ${formHook.errors.classroom && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: true })}
                      defaultValue={(props?.editData?.classroom) ? props?.editData?.classroom : ''}
                    />
                  </div>
                </div>
              ):formHook.unregister('classroom')}

              {!isMoocOrFree ? (
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='amountParticipants'>{t('labels.course_scheduling.amountParticipants')}</label>
                    {formHook.errors.amountParticipants && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      name='amountParticipants'
                      className={`form-control ${formHook.errors.amountParticipants && 'is-invalid'}`}
                      type='number'
                      pattern='[0-9]'
                      min='0'
                      ref={formHook.register({ required: true })}
                      defaultValue={(props?.editData?.amountParticipants) ? props?.editData?.amountParticipants : ''}
                    />
                  </div>
                </div>
              ): formHook.unregister('amountParticipants')}

              {isOnlineAndOpenLine ? (
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='schedule'>{t('labels.course_scheduling.schedule')}</label>
                    {formHook.errors.schedule && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <textarea
                      id='schedule'
                      name='schedule'
                      className={`form-control ${formHook.errors.schedule && 'is-invalid'}`}
                      ref={formHook.register({ required: true })}
                      defaultValue={props?.editData?.details?.schedule}
                    />
                  </div>
                </div>
              ):formHook.unregister('schedule')}

              <div className="col-md-12">
                <div className="form-group">
                  <div
                    style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'flex-end', marginBottom: '12px' }}
                  >
                    <label style={{marginRight: 'auto'}} htmlFor='observations'>{t('labels.course_scheduling.observations')}</label>
                    <ButtonComponent
                      onClick={() => updateOpenTechnicalGuideline(true)}
                      variant='secondary'
                      type='button'
                      className='button-attachment'
                    >
                      Lineamiento técnico
                    </ButtonComponent>
                    <ButtonComponent
                      onClick={() => updateOpenAttachments(true)}
                      variant='secondary'
                      type='button'
                      className='button-attachment'
                    >
                      Adjuntos para operación
                    </ButtonComponent>
                    <ButtonComponent
                      onClick={() => updateOpenAttachmentsStudent(true)}
                      variant='secondary'
                      type='button'
                      className='button-attachment'
                    >
                      Adjuntos para estudiantes
                    </ButtonComponent>
                  </div>
                  {formHook.errors.observations && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <textarea
                    id='observations'
                    name='observations'
                    className={`form-control ${formHook.errors.observations && 'is-invalid'}`}
                    ref={formHook.register({ required: true })}
                    defaultValue={props?.editData?.details?.observations}
                  />
                </div>
              </div>

              {isMoocOrFree && (
                <div>
                  <div className="d-flex align-items-center mb-2">
                    <h3 className="form-title">Ajustes de mooc o curso gratuito</h3>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor='serviceValidity'>Periodo de vigencia</label>
                      {formHook.errors.serviceValidity && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      <input
                        id='serviceValidity'
                        name='serviceValidity'
                        className={`form-control ${formHook.errors.serviceValidity && 'is-invalid'}`}
                        type='text'
                        placeholder='0h 0m 0s'
                        ref={formHook.register({ required: true })}
                        defaultValue={(props?.editData?.serviceValidity) ? durationFieldService.getDurationFormated(props?.editData?.serviceValidity) : ''}
                      />
                    </div>
                    {props.customErrors?.service_validity_invalid && <div className='custom-invalid-feedback'>{props.customErrors?.service_validity_invalid}</div>}
                  </div>
                </div>
              )}

              {!isMoocOrFree ? (
                <>
                  <CourseSchedulingModuleLayoutMaterialDelivery
                    formHook={formHook}
                    editData={props.editData}
                  />
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor='client'>{t('labels.course_scheduling.client')}</label>
                      <ReactSelectComponent
                        identifier='client'
                        options={listOfCompanies}
                        formHooks={formHook}
                        defaultValue={(props?.editData?.details?.client) ? [{ value: props?.editData?.details?.client?._id, label: props?.editData?.details?.client?.name }] : []}
                        isMulti={false}
                        required={true}
                      />
                      {formHook.errors.client && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    </div>
                  </div>
                </>
              ): formHook.unregister('client')}
              {schedulingStatusSpy?.label === 'Confirmado' ?
                <>
                  {!isMoocOrFree && (
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor='contact'>{t('labels.course_scheduling.contact')}</label>
                        <ReactSelectComponent
                          identifier='contact'
                          options={listOfContacts}
                          formHooks={formHook}
                          defaultValue={(props?.editData?.details?.contact) ? [{ value: props?.editData?.details?.contact?._id, label: `${props?.editData?.details?.contact?.profile?.first_name} ${props?.editData?.details?.contact?.profile?.last_name}` }] : []}
                          isMulti={false}
                          required={true}
                        />
                        {formHook.errors.contact && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      </div>
                    </div>
                  )}
                  {getContactObject() && !isMoocOrFree ?
                    <>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='material_contact_position'>{t('labels.material_delivery.material_contact_position')}</label>
                          <input
                            className={`form-control`}
                            type='text'
                            disabled
                            value={getContactObject() ? getContactObject().profile?.currentPosition : ''}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='material_contact_phone'>{t('labels.material_delivery.material_contact_phone')}</label>
                          <input
                            className={`form-control`}
                            type='number'
                            disabled
                            value={getContactObject() ? getContactObject().phoneNumber : ''}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor='material_contact_email'>{t('labels.material_delivery.material_contact_email')}</label>
                          <input
                            className={`form-control`}
                            type='text'
                            disabled
                            value={getContactObject() ? getContactObject().email : ''}
                          />
                        </div>
                      </div>
                    </>
                  :null}
                </>
              :formHook.unregister('contact')}

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='duration'>{t('labels.course_scheduling.duration')}</label>
                  {formHook.errors.duration && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='duration'
                    name='duration'
                    className={`form-control ${formHook.errors.duration && 'is-invalid'}`}
                    type='text'
                    placeholder='0h 0m 0s'
                    ref={formHook.register({ required: true })}
                    defaultValue={(props?.editData?.duration) ? durationFieldService.getDurationFormated(props?.editData?.duration) : ''}
                  // onChange={handleProgramDurationChange}
                  />
                </div>
                {props.customErrors?.duration_invalid && <div className='custom-invalid-feedback'>{props.customErrors?.duration_invalid}</div>}
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="">{t("modules.course_scheduling.program_in_design")}</label><br />
                  <label className={"content-input"}>
                    <input
                      type="radio"
                      name="in_design"
                      ref={formHook.register()}
                      value="1"
                      checked={radioValue === 1}
                      onChange={(e) => setRadioValue(parseInt(e.currentTarget.value))}
                    />
                    &nbsp;{t('labels.yes')}
                  </label>&nbsp;&nbsp;&nbsp;
                  <label className={"content-input"}>
                    <input
                      type="radio"
                      name="in_design"
                      ref={formHook.register()}
                      value="0"
                      checked={radioValue === 0}
                      onChange={(e) => setRadioValue(parseInt(e.currentTarget.value))}
                    />
                    &nbsp;{t('labels.not')}
                  </label>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex align-items-center mb-2">
                <h3 className="form-title">{t("modules.course_scheduling.certificate_information")}</h3>
              </div>
              {userService.can('permission:course_scheduling_certificate_multiple_configuration', 'module:course_scheduling') && (<div>
                <label className={"content-input"}>
                  <input
                    type="checkbox"
                    name="hasMultipleCertificate"
                    ref={formHook.register()}
                    defaultChecked={props.editData?.multipleCertificate?.status ? true : false}
                    disabled={!checkCertificateMultipleStatus() || isMoocOrFree}
                  />
                  &nbsp;¿Tiene multiple certificado?
                </label>
              </div>)}
              {props.customErrors?.hasMultipleCertificate_required && <div className='custom-invalid-feedback'>{props.customErrors?.hasMultipleCertificate_required}</div>}
              <label>{t('labels.certificate.certificate_delivery')}</label>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <label className={"content-input"}>
                  <input
                    type="checkbox"
                    name="certificate_clients"
                    ref={formHook.register()}
                    defaultChecked={props.editData?.certificate_clients ? true : false}
                  />
                  &nbsp;{t('labels.client')}
                </label>
                <label className={"content-input"}>
                  <input
                    type="checkbox"
                    name="certificate_students"
                    ref={formHook.register()}
                    defaultChecked={props.editData?.certificate_students ? true : false}
                  />
                  &nbsp;{t('labels.student')}
                </label>
              </div>
              {props.customErrors?.certificate_students_required && <div className='custom-invalid-feedback'>{props.customErrors?.certificate_students_required}</div>}
              {!hasMultipleCertificate && (
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='certificate'>{t('labels.certificate.certificate')}</label>
                    {formHook.errors.certificate && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='certificate'
                      name='certificate'
                      className={`form-control ${formHook.errors.certificate && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register()}
                      defaultValue={(props?.editData?.certificate) ? props?.editData?.certificate : ((props?.editData?.details?.program) ? props?.editData?.details?.program?.name : '')}
                    />
                  </div>
                </div>
              )}
              {auditorCertificate.status && props?.editData && !hasMultipleCertificate && (
                <>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor='auditor_certificate'>{t('labels.certificate.auditor_certificate')}</label>
                      {formHook.errors.auditor_certificate && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      <input
                        id='auditor_certificate'
                        name='auditor_certificate'
                        className={`form-control ${formHook.errors.auditor_certificate && 'is-invalid'}`}
                        type='text'
                        // defaultValue={auditorCertificate.name}
                        ref={formHook.register({ required: false })}
                        defaultValue={(props?.editData?.auditor_certificate) ? props?.editData?.auditor_certificate : auditorCertificate.name}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='auditor_modules'>{t('labels.course_scheduling.auditor_modules')}</label>
                    <ReactSelectComponent
                      identifier='auditor_modules'
                      options={listOfCourseSchedulings}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.auditor_modules) ? props?.editData?.details?.auditor_modules.map((r: any) => {return {value: r._id, label: r.course?.name}}) : []}
                      isMulti={true}
                      required={false}
                    />
                    {formHook.errors.auditor_modules && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
                </>
              )}
              <div style={{ marginBottom: '10px' }}>
                <ButtonComponent
                  onClick={() => setOpenAttachedCertificateCriteria(true)}
                  variant='secondary'
                  type='button'
                  className='button-attachment'
                >
                  Criterios de certificación
                </ButtonComponent>
              </div>
              {/* <div style={{ marginBottom: '10px' }}>
                <ButtonComponent
                  onClick={() => setOpenAttachedSpecialServiceConditions(true)}
                  variant='secondary'
                  type='button'
                  className='button-attachment'
                >
                  Condiciones especiales del servicio
                </ButtonComponent>
              </div> */}
              {userService.can('permission:course_scheduling_upload_approval_criteria', 'module:course_scheduling') && (
                <div style={{ marginBottom: '10px' }}>
                  <div className="d-flex align-items-center mb-2">
                    <h3 className="form-title">Criterios de aprobación</h3>
                  </div>
                  <ButtonComponent
                    onClick={() => setOpenAttachedApprovalCriteria(true)}
                    variant='secondary'
                    type='button'
                    className='button-attachment'
                  >
                    Criterios de aprobación
                  </ButtonComponent>
                </div>
              )}
              <div className="d-flex align-items-center mb-2">
                <h3 className="form-title">Datos para la certificación</h3>
              </div>
              <label>{t('labels.icons')}</label>
              <div className="container-icons-certificate">
                <InputFileComponent
                  as='image'
                  className='file-icon-form'
                  name='icon_1_file'
                  formHook={formHook}
                  limitSizeKB={fileSize}
                  defaultUrl={props.editData?.certificate_icon_1}
                  accept='image/png'
                  message={inputFileComponentMessage}
                />
                <InputFileComponent
                  as='image'
                  className='file-icon-form'
                  name='icon_2_file'
                  formHook={formHook}
                  limitSizeKB={fileSize}
                  defaultUrl={props.editData?.certificate_icon_2}
                  accept='image/png'
                  message={inputFileComponentMessage}
                />
              </div>

              <label>{t('labels.signature')}</label>
              {signatures.map((signature) => (
                <>
                  <div className='container-signature'>
                    <div className="container-icons-signature">
                      <InputFileComponent
                        as='image'
                        className='file-icon-form'
                        name={`${signature.field}_file`}
                        formHook={formHook}
                        limitSizeKB={fileSize}
                        defaultUrl={signature.body?.url}
                        accept='image/png'
                        message={inputFileComponentMessage}
                      />
                    </div>
                    <div className='container-data-signature'>
                      <input
                        name={`${signature.field}_name`}
                        type="text"
                        className='form-control'
                        ref={formHook.register({ required: false })}
                        defaultValue={signature.body?.name}
                        placeholder={`Nombre ${signature.label} firmante`}
                      />
                      <input
                        name={`${signature.field}_position`}
                        type="text"
                        className='form-control'
                        ref={formHook.register({ required: false })}
                        defaultValue={signature.body?.position}
                        placeholder={`Cargo ${signature.label} firmante`}
                      />
                      <input
                        name={`${signature.field}_company`}
                        type="text"
                        className='form-control'
                        ref={formHook.register({ required: false })}
                        defaultValue={signature.body?.company}
                        placeholder={`Empresa ${signature.label} firmante`}
                      />
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>

          {virtualOffertStatus && (
            <>
              <div className="d-flex align-items-center mb-2">
                <h3 className="form-title">{t("modules.course_scheduling.virtual_offert")}</h3>
              </div>

              <div className="row">

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor='serviceInformation'>Oferta del servicio</label>
                    <input
                      id='serviceInformation'
                      name='serviceInformation'
                      className={`form-control ${formHook.errors.serviceInformation && 'is-invalid'}`}
                      ref={formHook.register({ required: false, maxLength: OFFER_MAX_LENGTH })}
                      defaultValue={props?.editData?.details?.serviceInformation}
                    />
                    {formHook.errors.serviceInformation && (
                      <div className='invalid-feedback' style={{ display: 'initial' }}>
                        {formHook.errors.serviceInformation.type === 'maxLength' ? `Máximo ${OFFER_MAX_LENGTH} caracteres` : t('errors.this_field_is_required')}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor='longServiceInformation'>Oferta del servicio (Formato largo)</label>
                    <input
                      id='longServiceInformation'
                      name='longServiceInformation'
                      className={`form-control ${formHook.errors.longServiceInformation && 'is-invalid'}`}
                      ref={formHook.register({ required: false })}
                      defaultValue={props?.editData?.details?.longServiceInformation}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <Form.Check
                      type='switch'
                      id='hasCost'
                      name='hasCost'
                      label={t('labels.course_scheduling.hasCost')}
                      onChange={(event: any) => handleChangeHasCost(event)}
                      checked={hasCost}
                      ref={formHook.register()}
                      disabled={isMoocOrFree}
                    />
                  </div>
                </div>

                {hasCost && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor='priceCOP'>{t('labels.course_scheduling.priceCOP')}</label>
                        {formHook.errors.priceCOP && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                        <NumberFormat
                          thousandSeparator={true}
                          prefix={'$'}
                          value={priceCop.formated}
                          className={`form-control ${formHook.errors.priceCOP && 'is-invalid'}`}
                          onValueChange={(values) => {
                            const { formattedValue, value } = values;
                            setPriceCop({ formated: formattedValue, value });
                          }}
                        />
                        <input type="hidden" name="priceCOP" value={priceCop.value} ref={formHook.register({ required: true })} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor='priceUSD'>{t('labels.course_scheduling.priceUSD')}</label>
                        {formHook.errors.priceUSD && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                        <NumberFormat
                          thousandSeparator={true}
                          prefix={'$'}
                          value={priceUsd.formated}
                          className={`form-control ${formHook.errors.priceUSD && 'is-invalid'}`}
                          onValueChange={(values) => {
                            const { formattedValue, value } = values;
                            setPriceUsd({ formated: formattedValue, value });
                          }}
                        />
                        <input type="hidden" name="priceUSD" value={priceUsd.value} ref={formHook.register({ required: false })} />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor='discount'>{t('labels.course_scheduling.discount')}</label>
                            {formHook.errors.discount && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                            <input
                              id='discount'
                              name='discount'
                              className={`form-control ${formHook.errors.discount && 'is-invalid'}`}
                              type='number'
                              min='0'
                              max='100'
                              ref={formHook.register({ required: false })}
                              defaultValue={props?.editData?.details?.discount}
                              onChange={(event) => setDiscountStatus(event.target.value)}
                            />
                          </div>
                        </div>
                        {discountValue && discountValue !== '' && (discountValue as number) > 0 && (
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor='endDiscountDate'>{t('labels.course_scheduling.endDiscountDate')}</label>
                              <input
                                type='date'
                                className='form-control'
                                name='endDiscountDate'
                                defaultValue={moment.utc(props?.editData?.details?.endDiscountDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                                ref={formHook.register({ required: true })}
                              />
                              {formHook.errors.endDiscountDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                            </div>
                          </div>
                        )}

                      </div>

                    </div>
                  </>
                )}

                {props.customErrors?.cost_required && (
                  <>
                    <div className="col-md-12">
                      <div className='custom-invalid-feedback'>{props.customErrors?.cost_required}</div>
                    </div>
                  </>
                )}

                <div className="col-md-12">
                  <div className="form-group">
                    <div className='d-flex'>
                      <div className="form-group">
                        <Form.Check
                          type='switch'
                          id='publish'
                          name='publish'
                          label=''
                          defaultChecked={props?.editData?.details?.publish}
                          ref={formHook.register()}
                        />
                      </div>
                      <label htmlFor='publish'>{t('labels.course_scheduling.publish')}</label>
                    </div>
                    {props.customErrors?.publish_required && <div className='custom-invalid-feedback'>{props.customErrors?.publish_required}</div>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor='startPublicationDate'>{t('labels.course_scheduling.startPublicationDate')}</label>
                    <input
                      type='date'
                      className='form-control'
                      name='startPublicationDate'
                      defaultValue={props?.editData?.details?.startPublicationDate ? moment.utc(props?.editData?.details?.startPublicationDate).format('YYYY-MM-DD') : moment.utc().subtract('1','day').format('YYYY-MM-DD')}
                      ref={formHook.register({ required: true })}
                    />
                    {formHook.errors.startPublicationDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor='endPublicationDate'>{t('labels.course_scheduling.endPublicationDate')}</label>
                    <input
                      type='date'
                      className='form-control'
                      name='endPublicationDate'
                      defaultValue={props?.editData?.details?.endPublicationDate ? moment.utc(props?.editData?.details?.endPublicationDate).format('YYYY-MM-DD') : moment.utc().subtract('1','day').format('YYYY-MM-DD')}
                      ref={formHook.register({ required: true })}
                    />
                    {formHook.errors.endPublicationDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='enrollmentDeadline'>{t('labels.course_scheduling.enrollmentDeadline')}</label>
                    <input
                      type='date'
                      className='form-control'
                      name='enrollmentDeadline'
                      defaultValue={props?.editData?.details?.enrollmentDeadline ? moment.utc(props?.editData?.details?.enrollmentDeadline).format('YYYY-MM-DD') : moment.utc().subtract('1','day').format('YYYY-MM-DD')}
                      ref={formHook.register({ required: true })}
                    />
                    {formHook.errors.enrollmentDeadline && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>

              </div>
            </>
          )}
          <div className="row">
            <div className="col-12">
              {!props.viewer && (
                <div className='buttons-group'>
                  <div className=''>
                    <button className='btn btn-primary' type='submit' disabled={props.processing}>
                      {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                      {t('buttons.save')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

        </form>
      </fieldset>

      <ModalAttached
        open={openAttachments}
        onClose={() => updateOpenAttachments(false)}
        title="Archivos adjuntos"
        formHook={formHook}
        name='attachments'
        defaultValue={attachedId ? attachedId : props.editData?.details?.attachments}
        category='course_scheduling_attachments'
        onFileSaved={(e) => updateAttachedId(e._id)}
        preSaveMessage='Recuerda guardar la programación para guardar los cambios'
      />

      <ModalAttached
        open={openAttachmentsStudent}
        onClose={() => updateOpenAttachmentsStudent(false)}
        title="Archivos adjuntos para estudiantes"
        formHook={formHook}
        name='attachments_student'
        defaultValue={attachedStudentId ? attachedStudentId : props.editData?.details?.attachments_student}
        category='course_scheduling_attachments'
        onFileSaved={(e) => updateAttachedStudentId(e._id)}
        preSaveMessage='Recuerda guardar la programación para guardar los cambios'
      />

      <ModalAttached
        open={openTechnicalGuideline}
        onClose={() => updateOpenTechnicalGuideline(false)}
        defaultValue={attachedTechnicalGuidelineId ? attachedTechnicalGuidelineId : props.editData?.details?.technical_guideline}
        title="Lineamiento técnico"
        formHook={formHook}
        name='technical_guideline'
        onFileSaved={(e) => setAttachedTechnicalGuidelineId(e._id)}
        category='course_scheduling_technical_guideline'
        preSaveMessage='Recuerda guardar la programación para guardar los cambios'
      />

      <ModalAttached
        open={openAttachedApprovalCriteria}
        onClose={() => setOpenAttachedApprovalCriteria(false)}
        title="Criterios de probación"
        formHook={formHook}
        name='approval_criteria'
        defaultValue={attachedApprovalCriteriaId ? attachedApprovalCriteriaId : props.editData?.details?.approval_criteria}
        category='course_scheduling_approval_criteria'
        onFileSaved={(e) => setAttachedApprovalCriteriaId(e._id)}
        preSaveMessage='Recuerda guardar la programación para guardar los cambios'
      />

      <ModalAttached
        open={openAttachedCertificateCriteria}
        onClose={() => setOpenAttachedCertificateCriteria(false)}
        title="Criterios de certification"
        formHook={formHook}
        name='certificateCriteria'
        defaultValue={attachedCertificateCriteriaId ? attachedCertificateCriteriaId : props.editData?.details?.certificateCriteria}
        category='course_scheduling_certificate_criteria'
        onFileSaved={(e) => setAttachedCertificateCriteriaId(e._id)}
        preSaveMessage='Recuerda guardar la programación para guardar los cambios'
      />

      <ModalAttached
        open={openAttachedSpecialServiceConditions}
        onClose={() => setOpenAttachedSpecialServiceConditions(false)}
        title="Criterios especiales del servicio"
        formHook={formHook}
        name='specialServiceConditions'
        defaultValue={attachedSpecialServiceConditionsId ? attachedSpecialServiceConditionsId : props.editData?.details?.specialServiceConditions}
        category='course_scheduling_certificate_criteria'
        onFileSaved={(e) => setAttachedSpecialServiceConditionsId(e._id)}
        preSaveMessage='Recuerda guardar la programación para guardar los cambios'
      />

      <ModalReprogramingForm
        open={openReprogramingForm}
        onClose={(data) => reprogramingFormClosed(data)}
        title="Reprogramación de servicio"
      />

    </div>
  )
}

export default CourseSchedulingModuleLayout
